export default __webpack_public_path__ + "static/media/superheroes26.5528c6d8.png";